import React from "react";
import {SWHKProvider} from "./reducers/SWHKProvider";
import Preview from "./components/Preview";
import PayloadHandler from "./components/PayloadHandler";

const App = ({ callback, data, errors, onTest, testData, testing }) => {
    return(
          <SWHKProvider>
              <PayloadHandler callback={callback} data={data} errors={errors}/>
              <Preview callback={callback} data={data} onTest={onTest} testData={testData} testing={testing}/>
          </SWHKProvider>
    );
};

export default App;